"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClosedException_1 = __importDefault(require("./exceptions/ClosedException"));
const TimeoutException_1 = __importDefault(require("./exceptions/TimeoutException"));
class Utils {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static splitWsgData(wsgData) {
        if (wsgData.includes(',--Boundary')) {
            const index = wsgData.indexOf(',--Boundary');
            return [
                JSON.parse(wsgData.substring(1, index)),
                wsgData.substring(index + 1, wsgData.length - 1),
            ];
        }
        return JSON.parse(wsgData);
    }
    static debugWebSocket(_ws) {
        const ws = _ws;
        const send = ws.send.bind(ws);
        ws.send = async (str) => {
            await send(str);
            console.debug(`*** WebSocket outgoing message: ***
${JSON.stringify(JSON.parse(str), null, 2)}
******`);
        };
        ws.addEventListener('message', (mEvent) => {
            const event = mEvent;
            console.debug(`*** WebSocket incoming message: ***
${JSON.stringify(JSON.parse(event.data), null, 2)}
******`);
        });
        ws.addEventListener('open', (event) => {
            console.debug('WebSocket open event:', event);
        });
        ws.addEventListener('error', (event) => {
            console.debug('WebSocket error event:', event);
        });
        ws.addEventListener('close', (event) => {
            console.debug('WebSocket close event:', event);
        });
    }
    static waitForWebSocketMessage(ws, matchCondition, timeout = 60000) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Promise((resolve, reject) => {
            const checkHandle = setInterval(() => {
                if (ws.readyState === ws.CLOSED) {
                    clearInterval(checkHandle);
                    reject(new ClosedException_1.default());
                }
            }, 1000);
            const timeoutHandle = setTimeout(() => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                ws.removeEventListener('message', handler);
                clearInterval(checkHandle);
                reject(new TimeoutException_1.default());
            }, timeout);
            const handler = (mEvent) => {
                const event = mEvent;
                const [meta, body] = Utils.splitWsgData(event.data);
                if (matchCondition(meta)) {
                    ws.removeEventListener('message', handler);
                    clearInterval(checkHandle);
                    clearTimeout(timeoutHandle);
                    resolve([meta, body, event]);
                }
            };
            ws.addEventListener('message', handler);
        });
    }
}
exports.default = Utils;
//# sourceMappingURL=utils.js.map